import { render } from "./Boleto.vue?vue&type=template&id=a64acbce"
import script from "./Boleto.vue?vue&type=script&lang=js"
export * from "./Boleto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\BACKUP\\FrontEnd\\email-boleto-land\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__